import { render, staticRenderFns } from "./MerchantNotification.vue?vue&type=template&id=530e7fca&"
import script from "./MerchantNotification.vue?vue&type=script&lang=js&"
export * from "./MerchantNotification.vue?vue&type=script&lang=js&"
import style0 from "./MerchantNotification.vue?vue&type=style&index=0&id=530e7fca&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports